/* ==========================================================================
   Limavia — Sujetador moldeador · landing interactions (prefix: smb-)
   Loaded ONCE from the main buy section (smb-buybox). Uses event delegation
   on document so it also drives the FAQ, UGC carousel and other sections even
   though they don't load their own JS. It never touches cart logic: the native
   <product-form> + Kaching Bundles own that.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__smbInit) return;
  window.__smbInit = true;

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- GALLERY ---------------------------------------------------- */
  function gallery() {
    var g = $('[data-smb-gallery]');
    if (!g) return;
    var main   = $('[data-smb-main]', g);
    var track  = $('[data-smb-thumbs]');
    var dotsW  = $('[data-smb-dots]');
    var slides = $$('[data-smb-slide]', g);        // product slides only
    var colorSlide = $('[data-smb-color-slide]', g);
    var count  = slides.length;
    if (!main) return;

    function show(i) {
      if (count === 0) return;
      i = (i + count) % count;
      g.setAttribute('data-smb-index', i);
      if (colorSlide) colorSlide.hidden = true;
      slides.forEach(function (s, k) { s.hidden = (k !== i); });
      if (track) $$('[data-smb-thumb]', track).forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
      if (dotsW) $$('[data-smb-dot]', dotsW).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    /* show a color's own photo in the main gallery */
    function showColor(url) {
      if (!colorSlide || !url) return;
      var img = colorSlide.querySelector('img');
      if (img) img.src = url;
      slides.forEach(function (s) { s.hidden = true; });
      colorSlide.hidden = false;
      g.setAttribute('data-smb-index', '-1');
      if (track) $$('[data-smb-thumb]', track).forEach(function (t) { t.classList.remove('is-active'); });
      if (dotsW) $$('[data-smb-dot]', dotsW).forEach(function (d) { d.classList.remove('is-active'); });
    }
    function cur() { var c = parseInt(g.getAttribute('data-smb-index') || '0', 10); return c < 0 ? 0 : c; }

    g.__smbShow = show;
    g.__smbShowColor = showColor;
    g.addEventListener('click', function (e) {
      var a = e.target.closest('[data-smb-arrow]');
      if (a) { show(cur() + (a.getAttribute('data-smb-arrow') === 'next' ? 1 : -1)); }
    });
    if (track) track.addEventListener('click', function (e) {
      var t = e.target.closest('[data-smb-thumb]');
      if (t) show(parseInt(t.getAttribute('data-smb-thumb'), 10));
    });
    if (dotsW) dotsW.addEventListener('click', function (e) {
      var d = e.target.closest('[data-smb-dot]');
      if (d) show(parseInt(d.getAttribute('data-smb-dot'), 10));
    });

    /* swipe */
    var x0 = null;
    g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(cur() + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    if (count > 0) show(0);
  }

  /* ---------- COLOR SELECTOR — each colour shows its own photo ----------- */
  function colors() {
    var wrap = $('[data-smb-colors]');
    if (!wrap) return;
    var label = $('[data-smb-color-name]');
    var g = $('[data-smb-gallery]');
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-smb-color]');
      if (!b) return;
      $$('[data-smb-color]', wrap).forEach(function (o) { o.classList.remove('is-active'); });
      b.classList.add('is-active');
      if (label) label.textContent = b.getAttribute('data-smb-color-label') || '';
      var url = b.getAttribute('data-smb-color-img');
      if (g && g.__smbShowColor && url) g.__smbShowColor(url);
    });
  }

  /* ---------- SIZE FINDER (contorno + copa -> talla) --------------------- */
  function sizeFinder() {
    var box = $('#smb-size-finder');
    if (!box) return;
    var cSel = $('[data-smb-contorno]', box);
    var pSel = $('[data-smb-copa]', box);
    var out  = $('[data-smb-size-result]', box);
    if (!cSel || !pSel || !out) return;
    var contornos = (box.getAttribute('data-contornos') || '').split('|');
    var copas     = (box.getAttribute('data-copas') || '').split('|');
    var sizes     = (box.getAttribute('data-sizes') || '').split('|');
    function calc() {
      var ci = contornos.indexOf(cSel.value);
      var pi = copas.indexOf(pSel.value);
      if (ci < 0) ci = 0; if (pi < 0) pi = 0;
      var n = Math.round((ci / Math.max(1, contornos.length - 1) + pi / Math.max(1, copas.length - 1)) / 2 * (sizes.length - 1));
      n = Math.max(0, Math.min(sizes.length - 1, n));
      out.textContent = sizes[n];
    }
    cSel.addEventListener('change', calc);
    pSel.addEventListener('change', calc);
    calc();
  }

  /* ---------- ACCORDIONS (product info + FAQ, delegated) ----------------- */
  function accordions() {
    document.addEventListener('click', function (e) {
      var h = e.target.closest('[data-smb-acc-h]');
      if (!h) return;
      var item = h.closest('[data-smb-acc]');
      if (!item) return;
      var open = item.classList.contains('is-open');
      var group = h.getAttribute('data-smb-acc-single');
      if (group) {
        $$('[data-smb-acc].is-open').forEach(function (o) {
          if (o !== item && o.closest('[data-smb-acc-group="' + group + '"]')) o.classList.remove('is-open');
        });
      }
      item.classList.toggle('is-open', !open);
    });
  }

  /* ---------- UGC CAROUSEL ---------------------------------------------- */
  function ugc() {
    $$('[data-smb-ugc]').forEach(function (car) {
      var track = $('[data-smb-ugc-track]', car);
      if (!track) return;
      function step() {
        var card = $('[data-smb-ugc-card]', track);
        return card ? card.getBoundingClientRect().width + 16 : 300;
      }
      car.addEventListener('click', function (e) {
        var n = e.target.closest('[data-smb-ugc-next]');
        var p = e.target.closest('[data-smb-ugc-prev]');
        if (n) track.scrollBy({ left: step(), behavior: 'smooth' });
        if (p) track.scrollBy({ left: -step(), behavior: 'smooth' });
        var play = e.target.closest('[data-smb-ugc-play]');
        if (play) {
          var v = $('video', play.closest('[data-smb-ugc-card]'));
          if (v) { if (v.paused) { v.play(); play.classList.add('is-playing'); } else { v.pause(); play.classList.remove('is-playing'); } }
        }
      });
    });
  }

  /* ---------- VIDEOS: force muted autoplay + keep looping --------------- */
  function videos() {
    var vids = $$('.smb-ugc video');
    if (vids.length === 0) return;
    function play(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('playsinline', ''); v.loop = true;
      try { v.load(); } catch (e) {}
      play(v);
      v.addEventListener('canplay', function () { play(v); });
      v.addEventListener('loadeddata', function () { play(v); });
      /* if the browser pauses it (tab blur, power save), resume */
      v.addEventListener('pause', function () { if (!document.hidden) setTimeout(function () { play(v); }, 60); });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) vids.forEach(play);
    });
    /* kick again shortly after load in case the first attempt was blocked */
    setTimeout(function () { vids.forEach(play); }, 800);
  }

  /* ---------- STICKY BAR ------------------------------------------------- */
  function sticky() {
    var bar = $('[data-smb-sticky]');
    var anchor = $('[data-smb-atc-anchor]');   // native form wrapper
    if (!bar || !anchor) return;
    var footer = document.querySelector('.shopify-section-group-footer-group, footer[role="contentinfo"], footer.footer, footer.ajo-footer, footer');
    var srcPrice = $('[data-smb-price-src]');
    var dstPrice = $('[data-smb-price-dst]', bar);

    function onScroll() {
      var b = anchor.getBoundingClientRect().bottom;
      var show = b < 0;
      if (show && footer) {
        var ft = footer.getBoundingClientRect().top;
        if (ft < window.innerHeight - 20) show = false;
      }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    /* mirror the real price (rendered by theme / Kaching) */
    if (srcPrice && dstPrice) {
      var sync = function () { dstPrice.textContent = (srcPrice.textContent || '').trim(); };
      sync();
      try { new MutationObserver(sync).observe(srcPrice, { childList: true, subtree: true, characterData: true }); } catch (e) {}
    }
    /* click -> scroll to buy area, never adds to cart */
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-smb-sticky-cta]')) {
        var target = $('[data-smb-buy-anchor]') || $('[data-smb-atc-anchor]') || anchor;
        var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  }

  /* ---------- SCROLL-TO helpers (size link) ----------------------------- */
  function scrollLinks() {
    document.addEventListener('click', function (e) {
      var s = e.target.closest('[data-smb-scroll]');
      if (!s) return;
      e.preventDefault();
      var t = document.querySelector(s.getAttribute('data-smb-scroll'));
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
    });
  }

  function boot() {
    gallery(); colors(); sizeFinder(); accordions(); ugc(); videos(); sticky(); scrollLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);   // Theme Editor re-render
})();
